import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import {
  GuaranteesAccountPlacementStatus,
  GuaranteesExecutorMainDealConditionsStatus,
} from '~/store/guarantees/types.ts';

export const UAKDO_CONTROL_TEXT = {
  sectionStepLabel: '07',
  sectionTitle: 'Контроль - УАКДО',
  sectionDescription: 'Заповніть результати контролю перед передачею заявки на УАКДО-контролера.',
  executorMainDealConditionsStatusLabel: 'Умови основного договору',
  executorMainDealConditionsStatusPlaceholder: 'Оберіть статус виконання',
  unfulfilledConditionsDetailsLabel: 'Деталі невиконаних умов',
  coverageAccountPlacementStatusLabel: 'Статус розміщення грошового покриття',
  coverageAccountPlacementStatusPlaceholder: 'Оберіть статус розміщення',
  depositAccountPlacementStatusLabel: 'Статус розміщення депозиту',
  depositAccountPlacementStatusPlaceholder: 'Оберіть статус розміщення',
  loadingText: 'Завантаження даних контролю УАКДО...',
  saveButton: 'Зберегти',
  submitButton: 'Підтвердити',
  savedMessage: 'Дані контролю УАКДО збережено',
  submittedMessage: 'Дані контролю УАКДО підтверджено. Заявку передано на УАКДО-контролера.',
  successCloseButton: 'Закрити',
  accessDeniedText: 'У вас немає доступу до кроку контролю УАКДО.',
} as const;

export const EXECUTOR_MAIN_DEAL_CONDITIONS_STATUS_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesExecutorMainDealConditionsStatus }
> = [
  {
    value: GuaranteesExecutorMainDealConditionsStatus.PERFORMED,
    label: 'Виконано',
  },
  {
    value: GuaranteesExecutorMainDealConditionsStatus.NOT_PERFORMED,
    label: 'Не виконано',
  },
];

export const ACCOUNT_PLACEMENT_STATUS_OPTIONS: Array<
  TAutocompleteOption & { value: GuaranteesAccountPlacementStatus }
> = [
  {
    value: GuaranteesAccountPlacementStatus.PLACED_FULLY,
    label: 'Розміщено повністю',
  },
  {
    value: GuaranteesAccountPlacementStatus.PLACED_PARTIALLY,
    label: 'Розміщено частково',
  },
  {
    value: GuaranteesAccountPlacementStatus.NOT_PLACED,
    label: 'Не розміщено',
  },
];
